'use client';

import { redirect } from 'next/navigation';

export default function CareersRedirect() {
  // Get the user's language from localStorage (default to 'ar')
  const language = localStorage.getItem('i18nextLng') || 'ar';

  // Redirect /careers → language-specific careers page
  redirect(`/${language}/careers`);
}
